import ScheduleOutlined from '@mui/icons-material/ScheduleOutlined';
import { Grid, Stack, Switch, Typography, useTheme } from '@mui/material';
import { Visitor } from 'graphql/generated/graphqlTypes';
import useTranslation from 'hooks/useTranslation/useTranslation';
import { getVisitorMembershipByVisitorGroupId } from 'utils/Visitor/visitor';
import { formatDate } from 'v2/utils/dateTime';

interface Props {
  index: number;
  member: Visitor;
  visitorGroupId: string;
  isKeyManager: boolean;
  loading: boolean;
  onToggle: (becomeKeyManager: boolean) => void;
}

const InvitedMemberRow = ({ index, member, visitorGroupId, isKeyManager, loading, onToggle }: Props) => {
  const theme = useTheme();
  const { translation } = useTranslation();
  const expirationDate = getVisitorMembershipByVisitorGroupId(member, visitorGroupId)?.expirationDate;

  return (
    <Grid
      id={`invited-member-row-${index}`}
      container
      direction="row"
      alignItems="flex-start"
      justifyContent="space-between"
      padding="16px"
      sx={{ backgroundColor: theme.custom.background.level2 }}
    >
      <Stack direction="column" gap={0.5}>
        <Typography variant="body1">{member.name}</Typography>
        {expirationDate && (
          <Stack direction="row" alignItems="center" gap={0.5}>
            <ScheduleOutlined fontSize="extraSmall" sx={{ color: theme.palette.text.secondary }} />
            <Typography variant="body2" color="textSecondary">
              {`${translation.expires} ${formatDate(expirationDate, 'dateTime')}`}
            </Typography>
          </Stack>
        )}
      </Stack>
      <Stack direction="row" alignItems="center" gap={1}>
        <Typography variant="body2">{translation.key_manager}</Typography>
        <Switch
          id={`invited-member-row-${index}-key-manager-switch`}
          size="small"
          checked={isKeyManager}
          onChange={(_, checked) => onToggle(checked)}
          disabled={loading}
        />
      </Stack>
    </Grid>
  );
};

export default InvitedMemberRow;
